import React from "react"
import * as AppConstants from "../../../../utility/AppConstants"
import TabTotali from "../multiAnno/TabTotali"
import TabPersoneFisiche from "../multiAnno/TabPersoneFisiche"
import TabSocietaPersone from "../multiAnno/TabSocietaPersone"
import TabSocCapitaliEntiNonCommerciali from "./TabSocCapitaliEntiNonCommerciali"
import TabMacroareeTerritoriali from "./TabMacroareeTerritoriali"

import TabGrafici from "../TabGrafici"
import * as Utility from "../../../../utility/Utility"
import { Tabs, Messages } from "@sogei/react-web-components-catalog"
import { ResponseDatiNazionaliMultiAnno } from "@/utility/model"

function TabNazionaliMultiAnno(props: any) {
    let codiciIsa = (props.datiNazionali as ResponseDatiNazionaliMultiAnno[]).map((e) => e.codIsa)
    const [
        macroareeTerritoriali,
        macroareeTerritoriali2,
        macroareeTerritoriali3
    ] = props.macroareeTerritoriali
    const arrListaMob = [
        macroareeTerritoriali?.listaMob ?? [],
        macroareeTerritoriali2?.listaMob?? [],
        macroareeTerritoriali3?.listaMob ??[]
    ]
    const maxLengthMobs = Math.max(...arrListaMob.map((e) => e.length))

    let infoCodIsa =
        props.codIsa != "@@" &&
        props.codIsa != "" &&
        [...new Set(codiciIsa)].length > 1
            ? codiciIsa
            : ["","",""]
    const items = [
        {
            title: (
                <>
                    <i className="fab fa-font-awesome-flag mr-2"></i>
                    {AppConstants.TAB_TOTALI}
                </>
            ),
            titleHeading: "h1",
            body: (
                <TabTotali
                    codIsa={props.codIsa}
                    macroarea={props.macroarea}
                    totale={props.datiNazionali.totale}
                    datiNazionali={props.datiNazionali}
                    macroareeTerritoriali={props.macroareeTerritoriali}
                    anno={props.anno}
                />
            )
        }
    ]

    items.push(
        {
            title: (
                <>
                    <i className="fab fa-font-awesome-flag mr-2"></i>
                    {AppConstants.TAB_PERSONE_FISICHE}
                </>
            ),
            titleHeading: "h1",
            body: (
                <TabPersoneFisiche
                    codIsa={props.codIsa}
                    macroarea={props.macroarea}
                    anno={props.anno}
                />
            )
        },
        {
            title: (
                <>
                    <i className="fab fa-font-awesome-flag mr-2"></i>
                    {AppConstants.TAB_SOCIETA_PERSONE}
                </>
            ),
            titleHeading: "h1",
            body: (
                <TabSocietaPersone
                    codIsa={props.codIsa}
                    macroarea={props.macroarea}
                    anno={props.anno}
                />
            )
        },
       
        {
            title: (
                <>
                    <i className="fab fa-font-awesome-flag mr-2"></i>
                    {AppConstants.TAB_SOC_CAPITALI_ENTI_COMMERCIALI}
                </>
            ),
            titleHeading: "h1",
            body: (
                <TabSocCapitaliEntiNonCommerciali
                    codIsa={props.codIsa}
                    macroarea={props.macroarea}
                    anno={props.anno}
                />
            )
        }
    )

    if (
        props.codIsa !== null &&
        props.codIsa !== undefined &&
        props.codIsa.length > 0 &&
        props.macroareeTerritoriali !== null &&
        maxLengthMobs > 0
    ) {
        items.push({
            title: (
                <>
                    <i className="fab fa-font-awesome-flag mr-2"></i>
                    {AppConstants.TAB_MACROAREE_TERRITORIALI}
                </>
            ),
            titleHeading: "h1",
            body: (
                <TabMacroareeTerritoriali
                    codIsa={props.codIsa}
                    macroarea={props.macroarea}
                    totalePersoneFisiche={
                        props.datiNazionali.totalePersoneFisiche
                    }
                    personeFisicheRe={props.datiNazionali.personeFisicheRe}
                    personeFisicheRg={props.datiNazionali.personeFisicheRg}
                    personeFisicheRf={props.datiNazionali.personeFisicheRf}
                    datiNazionali={props.datiNazionali}
                    macroareeTerritoriali={props.macroareeTerritoriali}
                    anno={props.anno}
                    infoCodIsa={infoCodIsa}
                />
            )
        })
    }
    items.push({
        title: (
            <>
                <i className="fab fa-font-awesome-flag mr-2"></i>
                {AppConstants.TAB_GRAFICI}
            </>
        ),
        titleHeading: "h1",
        body: (
            <TabGrafici
                codIsa={props.codIsa}
                macroarea={props.macroarea}
                macroareasigla={Utility.trascodificaMacroArea(props.macroarea)}
                datiNazionali={props.datiNazionali}
                anno={props.anno}
            />
        )
    })

    return (
        <div className="row">
            <div className="col-12">
                <Tabs
                    items={items}
                    isReverseType={true}
                    //onShow={(e: any) => console.log(e)}
                />
                 
            </div>
        </div>
    )
}

export default TabNazionaliMultiAnno
